import Request from '@Core/xhr'
import Errors from '@Core/errors'
import to from '@Utils/to'

export default ( user ) => {
  return {

    namespaced: true,

    state: {
      user: user || {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        address: null,
        zip: null,
        city: null,
        country: App.lang.$t('countries.1'),
        phone: null,
        company: null,
        vat_id: null,
        vat: 0
      },
      loading: false,
      initialized: false,
      loginErrors: new Errors(),
      registerErrors: new Errors()
    },

    // mutating the state
    // mutations are always synchronous
    mutations: {

      setUser (state, {user}) {
        state.user = user
        state.initialized = true
      },

      setLoginErrors (state, {errors}) {
        state.loginErrors = errors
      },

      setRegisterErrors (state, {errors}) {
        state.registerErrors = errors
      },

      setLoading (state, {loading}) {
        state.loading = loading
      }

    },

    // commits the mutation, it's asynchronous
    // use actions for performing server requests without blocking
    // application while waiting for the response
    actions: {
      async getUser ({commit, state}) {
        if (!state.loading) {
          commit('setLoading', { loading: true })
          let request = new Request()
          let [, user] = await to(request.get(`/${App.lang.$t('routes.profile')}`))
          commit('setLoading', { loading: false })
          user && commit('setUser', {user})
        }
      },

      async login ({commit, dispatch}, { email, password, remember }) {
        return new Promise(async (resolve, reject) => {
          let request = new Request({ email, password, remember })
          let [errors, user] = await to(request.post('/login'))

          errors
            ? commit('setLoginErrors', {errors})
            : commit('setUser', {user})

          !errors && resolve(true)

          //- Request cart items if user has discounts - for price recalculations
          !errors && dispatch('cart/requestItems', { force: true }, { root: true })
        })
      },

      async register ({ commit }, { data }) {
        let request = new Request(data)
        let [errors, user] = await to(request.post('/register'))

        errors
          ? commit('setRegisterErrors', {errors})
          : commit('setUser', {user})
      },

      async registerGuest ({ commit }, { data }) {
        let request = new Request(data)
        let [errors, user] = await to(request.post('/register/guest'))

        errors
          ? commit('setRegisterErrors', {errors})
          : commit('setUser', {user})
      }

    },

    // showing things, not mutating state
    getters: {
      loggedIn: state => state.user && state.user.id != null,
      isGuest: (state, {loggedIn}) => loggedIn && state.user.id < 1000000000
    }
  }
}
